// These functions are needed by all the functions in this file o directly in the start
import { debugLog } from "./lb.js";
import { initializeApp } from "firebase/app";
import { firebaseConfig } from "./const.js";
import { algoliaConfig } from "./const.js";
import { minWidth } from "./const.js";
import { sanitizeText } from "./exports/sanitize.js";
import { copyObj } from "./lb.js";
import { getContrastColor } from './lb.js';

export var auth = new Object();
export var dbFirestoreLite = new Object();
export var dbFirestoreRT = new Object();
export var storage = new Object();
export var dbCache = { "references": {}, "catalog": {}, "userProfile": {}, "products": {}, "info": { "orphans": 0, "count": 0 }, "newProduct": {}, "prodSearch": [], "exchange":{}, "smartLoad":{} };
export var xStage = {};
export var writeControl = { "phase": "run", "pendingWrites": 0, "updateMenuNow": false, "dbPurge": false };
export var order = [];
export var refStructure = { "attribute": {}, "brand": {}, "collection": {}, "category": {}, "variant": {}, "price": {}, "profile": {}, "warehouse": {} };
export var ktBig = true;
export var bannerBig = true;

var catalogRTFuse = true;
var panelRTFuse = true;
const urlParams = new URLSearchParams(window.location.search);
const app = initializeApp(firebaseConfig);

main();

async function main() {
  debugLog("CATALOGA", "Starting APP");

    // Aplicación del color del estilo a la página
    let primaryColor = window.initialPrimaryColor;
    let accentColor = window.initialAccentColor;
    if (!primaryColor.startsWith('#'))  { 
      primaryColor = '#EEEEEE';
      accentColor = '#606060'
    }
    const styleElement = document.getElementById('dynamic-colors');
    if (styleElement)   styleElement.innerHTML = 
      `:root {--mdl-color-primary: ${primaryColor};--mdl-color-accent: ${accentColor};--mdl-color-primary-contrast: ${getContrastColor(primaryColor)};}`;

  for (const rawKey of urlParams.keys()) {
    const key = sanitizeText(rawKey); // Sanitizing the key to avoid XSS attacks
    // eslint-disable-next-line security/detect-object-injection
    if (key) { xStage[key] = urlParams.get(rawKey); } // Only set if the key is not empty after sanitization
  }

  if (window.navigator.onLine) {
    /*if (typeof FastClick !== 'undefined' && FastClick.attach) {
        FastClick.attach(document.body);
        debugLog("main","FastClick inicializado...");
    }*/
    // Dynamically importing the required modules only if needed
    //const { getAnalytics } = await import("firebase/analytics");
    const { getAuth } = await import("./exports/getAuth.js");
    const { getFirestore: getFirestoreLite } = await import("./exports/getFirestoreLite.js");
    const { getStorage } = await import("./exports/getStorage.js");
    const { lbSimplify } = await import("./exports/lbSimplify.js");
    // Execution of the imported functions
    //const analytics = getAnalytics(app);
    auth = getAuth(app);          // Start Authentication
    auth.languageCode = "es";
    dbFirestoreLite = getFirestoreLite(app);       // Start Database  
    storage = getStorage(app)     // Start Storage    

    //const fullPath = window.location.pathname;
    //const cleanPath = fullPath.startsWith("/") ? fullPath.substring(1) : fullPath;
    //const finalPath = cleanPath.endsWith("/") ? cleanPath.slice(0, -1) : cleanPath;
    //const catalogId = lbSimplify(finalPath)
    
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    const catalogId = pathSegments.length > 0 ? lbSimplify(pathSegments[0]) : "";
    if (pathSegments.length >= 2 && !xStage["stage"])     xStage["stage"] = pathSegments[1].toUpperCase();
    if (pathSegments.length >= 3 && !xStage["substage"])  xStage["substage"] = pathSegments[2];
    
    const primaryRoute = pathSegments.length > 0 ? pathSegments[0].toLowerCase() : "";
    if (/^[a-z0-9_ñ]{4,30}$/.test(catalogId) && !["app.html", "app", "panel", "dashboard"].includes(catalogId)) {
      if (xStage["mode"] === "resetPassword") {
        xStage["stage"] = "AUTH";
      }
      const { dbGetData } = await import("./exports/dbGetData.js");
      const { authObsApp } = await import("./exports/authObsApp.js");
      if (await dbGetData(catalogId)) {
        authObsApp();
        resizeManager();
        detectChangeURL();
        const { startDragAndDrop } = await import("./exports/startDragAndDrop.js");
        startDragAndDrop();
      }
    }
    else if (xStage["mode"] === "resetPassword" || ["", "app.html", "app", "panel", "dashboard"].includes(primaryRoute)) {
      const { uiPanelPrep } = await import("./exports/uiPanelPrep.js");
      const { authObsPanel } = await import("./exports/authObsPanel.js");
      uiPanelPrep();
      authObsPanel();
    }
    else {
      const { uiMessage } = await import("./exports/uiMessage.js");
      uiMessage({ "type": "dialog", "text": "⚠️ El Identificador de catálogo no es válido", "behavior": "close" });
    }
  }
  else {
    const { uiMessage } = await import("./exports/uiMessage.js");
    uiMessage({ "type": "dialog", "text": "⚠️ No hay conexión a internet. Intente cargar de nuevo", "behavior": "close" });
  }
}

// ******************************************************************************************** Start the Real Time Dabtabase functionality
export async function loadRTCatalog() {
  if (catalogRTFuse) {
    debugLog("loadRTCatalog", "Loading Real Time for Catalogs")
    catalogRTFuse = false;
    // Loading real time 
    const { getFirestore: getFirestoreRT } = await import("./exports/getFirestoreRT.js");
    const { listenerCatalog } = await import("./exports/listenerCatalog.js");
    const { listenerReferences } = await import("./exports/listenerReferences.js");
    const { listenerProducts } = await import("./exports/listenerProducts.js");
    dbFirestoreRT = getFirestoreRT(app);
    await listenerCatalog();
    await listenerReferences();
    await listenerProducts();
  }
}

// ******************************************************************************************** Start the Real Time Dabtabase functionality
export async function loadRTPanel() {
  if (panelRTFuse) {
    debugLog("loadFullRT", "Loading Real Time for Panel")
    panelRTFuse = false;
    // Loading real time 
    const { getFirestore: getFirestoreRT } = await import("./exports/getFirestoreRT.js");
    const { listenerMyCatalogs } = await import("./exports/listenerMyCatalogs.js");
    dbFirestoreRT = getFirestoreRT(app);
    listenerMyCatalogs();
  }
}

// ******************************************************************************************** Declares the listener for the window size
function resizeManager() {
  window.addEventListener("resize", () => {     // Window event for the management of the table size
    if (xStage["stage"] == "SETKARDEX") {
      if ((window.innerWidth >= minWidth["kardex"]) && (!ktBig)) {
        $("#kardexTable").trigger("loadBigTable");
        ktBig = true;
      }
      if ((window.innerWidth < minWidth["kardex"]) && (ktBig)) {
        $("#kardexTable").trigger("loadLittleTable");
        ktBig = false;
      }
    }
    else if (xStage["stage"] == "HOME") {
      if ((window.innerWidth >= minWidth["banner"]) && (!bannerBig)) {
        $("#bannerIMG").trigger("loadBigBanner");
        bannerBig = true;
      }
      if ((window.innerWidth < minWidth["banner"]) && (bannerBig)) {
        $("#bannerIMG").trigger("loadLittleBanner");
        bannerBig = false;
      }
    }
  });
}

// ******************************************************************************************** Declares the listener for the window URL change
async function detectChangeURL() {
  const { uiTriggerLoad } = await import("./exports/uiTriggerLoad.js");
  window.addEventListener("popstate", (_event) => {
    debugLog("detectChangeURL - User surfed on history", window.location.href);
    const urlParameters = new URLSearchParams(window.location.search);
    debugLog("detectChangeURL - urlParameters", urlParameters.size);
    if (urlParameters.size > 0) {
      for (const rawKey of urlParameters.keys()) {
        const key = sanitizeText(rawKey);                   // Sanitizing the key to avoid XSS attacks
        // eslint-disable-next-line security/detect-object-injection
        if (key) xStage[key] = urlParameters.get(rawKey);  // Only set if the key is not empty after sanitization
      }
    } else if (_event.state && _event.state.stage) {
      xStage["stage"] = _event.state.stage;
      xStage["substage"] = _event.state.substage || "";
    } else {
      const pathSegs = window.location.pathname.split("/").filter(Boolean);
      if (pathSegs.length >= 2) {
        xStage["stage"] = sanitizeText(pathSegs[1]).toUpperCase();
        xStage["substage"] = pathSegs.length >= 3 ? sanitizeText(pathSegs[2]) : "";
      } else {
        xStage["stage"] = "HOME";
        xStage["substage"] = "";
      }
    }
    debugLog("detectChangeURL - xstage - copy", copyObj(xStage));
    uiTriggerLoad(false, false)
  });
}

// ******************************************************************************************** Returns a product search
// parameters = { searchText:"Text" , restrictedSearchWord:"Text"}
export async function searchProdDocsIDs({ brandsArray, categoryArray, wordsArray }) {
    debugLog("searchProdDocsIDs", { brandsArray, categoryArray, wordsArray });
    const { algoliasearch } = await import("algoliasearch");
    const algoliaClient = algoliasearch(algoliaConfig.appId, algoliaConfig.searchApiKey);
    const userWordsQuery = wordsArray.join(' ');
    const catalogSearchToken = `*${Object.keys(dbCache["catalog"])[0]}*`;
    const requestedSearch = userWordsQuery ? `${userWordsQuery} ${catalogSearchToken}` : catalogSearchToken;
    const brandFiltersGroup = brandsArray.map(id => `brand:${id}`).join(' OR '); 
    const categoryFiltersGroup = categoryArray.map(id => `category:${id}`).join(' OR '); 
    let algoliaFilters = ''; 

    if (brandFiltersGroup)  {
      algoliaFilters = `(${brandFiltersGroup})`; 
      if (categoryFiltersGroup) algoliaFilters += ` AND (${categoryFiltersGroup})`;
    }
    else if (categoryFiltersGroup)  algoliaFilters = `(${categoryFiltersGroup})`;
    const queries = [];    
    
    if (wordsArray.length > 0) {   // CASO A: Hay Texto Libre
        queries.push({      // CONSULTA A: Busqueda flexible de la cadena en title y model junto con los filtros de marca y categoría (si los hay) en el catálogo.
            indexName: algoliaConfig.indexName,
            query: requestedSearch,
            params: { restrictSearchableAttributes: ['title', 'model','path'], filters: algoliaFilters, hitsPerPage: 1000, attributesToRetrieve: ['objectID'] }
        });
        
        queries.push({  // CONSULTA B: Búsqueda exacta de la cadena en sku y barcode en el catálogo
            indexName: algoliaConfig.indexName,
            query: requestedSearch,
            params: { restrictSearchableAttributes: ['sku', 'barcode','path'], filters: algoliaFilters, typoTolerance: false, hitsPerPage: 1000, attributesToRetrieve: ['objectID'] }
        });
    } 
    
    else {   // CASO B: Búsqueda Solo de Filtros (Solo Marcas/Categorías)
        queries.push({  // Usamos el token del catálogo como query Y los filtros de marca/categoría
            indexName: algoliaConfig.indexName,
            query: requestedSearch,
            params: { restrictSearchableAttributes: ['path'], filters: algoliaFilters, hitsPerPage: 1000, attributesToRetrieve: ['objectID'] }
        });
    }

    if (queries.length === 0) { 
        dbCache["prodSearch"] = [];
        debugLog("La consulta está vacía. No se ha realizado búsqueda.");
        return;
    }
    
    try {
        const response = await algoliaClient.search(queries); 
        const allHits = [...(response.results[0]?.hits || []),...(response.results[1]?.hits || [])];
        const uniqueObjectIDs = Array.from(new Set(allHits.map(hit => hit.objectID)));
        dbCache["prodSearch"] = uniqueObjectIDs;
        debugLog("IDs de documentos que cumplen con la búsqueda:", dbCache["prodSearch"]);
    } catch (error) {
        debugLog("Error durante la búsqueda:", error); 
        dbCache["prodSearch"] = [];
    }
}